import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import {
  FollowingFeedRequest,
  FollowingFeedResponse,
} from 'types/interfaces/followingFeed';

export const followingFeedApi = createApi({
  reducerPath: 'followingFeedApi',
  baseQuery,
  tagTypes: ['FollowingFeed'],
  endpoints: (builder) => ({
    getFollowingFeed: builder.query<FollowingFeedResponse, FollowingFeedRequest>({
      query: ({ cursor, type, limit = 20 } = {}) => {
        const params = new URLSearchParams();
        params.append('limit', String(limit));
        if (cursor) params.append('cursor', cursor);
        if (type) params.append('type', type);
        return {
          url: `/feed/following?${params.toString()}`,
          method: 'GET',
          requiresAuth: true,
        };
      },
      // Separate cache per `type` filter, shared across cursor pages.
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}:${queryArgs?.type ?? 'ALL'}`;
      },
      merge: (currentCache, newItems, { arg }) => {
        if (!arg.cursor) {
          return newItems;
        }
        const existingIds = new Set(currentCache.events.map((e) => e.id));
        const uniqueNew = newItems.events.filter((e) => !existingIds.has(e.id));
        currentCache.events.push(...uniqueNew);
        currentCache.nextCursor = newItems.nextCursor;
        currentCache.hasMore = newItems.hasMore;
      },
      forceRefetch({ currentArg, previousArg }) {
        return (
          currentArg?.cursor !== previousArg?.cursor ||
          currentArg?.type !== previousArg?.type
        );
      },
      providesTags: ['FollowingFeed'],
      keepUnusedDataFor: 120,
    }),
  }),
});

export const { useGetFollowingFeedQuery } = followingFeedApi;
